import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { transferSchema } from 'pages/NestedCustomers/schema/transferSchema'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'
import { generateReference } from 'utils/utils'

export const useMoveFormState = () => {
  const { t } = useTranslation()

  const formSchema = transferSchema(t)

  const form = useForm<MovePayload>({
    resolver: yupResolver(formSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      walletTransferType: WalletTransferType.MAIN,
      customerReference: '',
      destinationWallet: '',
      amount: '',
      paymentReference: generateReference(),
    },
  })
  const formValues = form.watch()

  return {
    state: form.formState,
    values: formValues,
    register: form.register,
    setValue: form.setValue,
    trigger: form.trigger,
    clearErrors: form.clearErrors,
    setError: form.setError,
    watch: form.watch,
  }
}
